// src/pages/Dashboard/Restaurants.jsx
import React, { useState, useEffect } from 'react';
import UsersTable from '../../components/Layout/Dashboard/Users/UsersTable';

const Users = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    setIsDark(localStorage.getItem('theme') === 'dark');
  }, []);

  return <UsersTable isDark={isDark} />;
};

export default Users;